import { connectRouter, RouterState } from "connected-react-router";
import { combineReducers } from "redux";
import { ReduxState } from "../Definitions/Definitions";
import { AuthenticatedReducer, CurrentUserReducer } from "./CurrentUserReducer";
import { SnackbarReducer } from "./SnackbarReducer";
import { ThemeReducer } from "./ThemeReducer";

//@ts-ignore
import { History } from "history";

//add custom reducers in this file
export const createRootReducer = (history: History) => combineReducers<ReduxState>({
    router: connectRouter(history),
    currentUser: CurrentUserReducer,
    authenticated: AuthenticatedReducer,
    snackbarState: SnackbarReducer,
    theme: ThemeReducer
});
